// Mock article data since articles are not stored in Strapi. Add new articles at the top.
const articles = [
    {
        id: 'derfor-er-investering-relevant-for-pensionister',
        slug: 'derfor-er-investering-relevant-for-pensionister',
        title: 'Få 3 gode råd om <span class="color-highlight">investering</span> som <span class="color-highlight">pensionist</span>',
        date: new Date(2024, 11, 13),
        resume: 'Den rigtige måde at investere på i seniortilværelsen kan give dig en bedre økonomi. Find ud af, hvad du skal være opmærksom på her. Læs mere.',
        image: '/static/gfx/content/articles/penly-article-20.jpg',
        blog_category: {
            id: 'investering',
            title: 'Investering',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
        ],
    },
    {
        id: 'udskyd-atp',
        slug: 'udskyd-atp',
        title: 'Udskyd udbetaling af ATP pension og få  <span class="color-highlight">fordoblet udbetalingen</span>',
        date: new Date(2024, 9, 1),
        resume: 'Hvad vil det sige at udskyde udbetalingen af ATP pension - og hvem kan have glæde af det? Få svaret i denne artikel. Læs mere her.',
        image: '/static/gfx/content/articles/udskyd-atp.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'oekonomisk-raadgivning',
                name: 'Økonomisk rådgivning',
            },
        ],
    },
    {
        id: 'hvordan-pavirker-din-formue-din-folkepension',
        slug: 'hvordan-pavirker-din-formue-din-folkepension',
        title: 'Hvordan påvirker din formue din <span class="color-highlight">folkepension</span>?',
        date: new Date(2024, 5, 1),
        resume: 'Din formue påvirker de ydelser du kan få som pensionist. For eksempel gives ældrechecken kun til de pensionister som er allermindst formuende. Her ser vi nærmere på, hvad du skal være opmærksom på i forhold til formue og offentlige ydelser.',
        image: '/static/gfx/content/articles/penly-article-19.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'oekonomisk-raadgivning',
                name: 'Økonomisk rådgivning',
            },
        ],
    },
    {
        id: 'saadan-sparer-du-smartest-op-i-aarene-inden-pension',
        slug: 'saadan-sparer-du-smartest-op-i-aarene-inden-pension',
        title: 'SÅDAN <span class="color-highlight">SPARER DU SMARTEST OP</span>  I ÅRENE INDEN PENSION',
        date: new Date(2024, 5, 1),
        resume: 'Få de uvildige rådgiveres bedste råd til at spare optimalt op i årene inden pension - uanset om du betaler topskat eller ej. Læs mere.',
        image: '/static/gfx/content/articles/penly-article-18.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'pensionsopsparing',
                name: 'Pensionsopsparing',
            },
            {
                id: 'oekonomisk-raadgivning',
                name: 'Økonomisk rådgivning',
            },
        ],
    },
    {
        id: 'kan-jeg-straekke-min-ratepension',
        slug: 'kan-jeg-straekke-min-ratepension',
        title: 'Kan jeg <span class="color-highlight">strække</span> min ratepension?',
        date: new Date(2024, 5, 1),
        resume: 'Lær hvordan og hvornår du skal starte udbetalingen af dine ratepensioner for at optimere din økonomi. Læs mere her.',
        image: '/static/gfx/content/articles/penly-article-17.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'ratepension',
                name: 'Ratepension',
            },
            {
                id: 'oekonomisk-raadgivning',
                name: 'Økonomisk rådgivning',
            },
        ],
    },
    {
        id: 'se-dig-godt-for-inden-du-koeber-testamente-paa-nettet',
        slug: 'se-dig-godt-for-inden-du-koeber-testamente-paa-nettet',
        title: 'Se dig godt for inden du køber <span class="color-highlight"> testamente</span> på nettet',
        date: new Date(2024, 2, 19),
        resume: 'Det kan blive en dyr affære at købe juridiske dokumenter på nettet. Hør hvad du skal være særligt opmærksom på og hvorfor. Læs mere her.',
        image: '/static/gfx/content/articles/penly-article-16.jpg',
        blog_category: {
            id: 'jura',
            title: 'Jura',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'saadan-paavirkes-din-oekonomi-naar-du-stopper-med-at-arbejde',
        slug: 'saadan-paavirkes-din-oekonomi-naar-du-stopper-med-at-arbejde',
        title: 'Fra arbejde til <span class="color-highlight"> pension</span> - hvordan påvirker det <span className="color-highlight"> økonomien</span>?',
        date: new Date(2023, 10, 26),
        resume: 'Overgangen fra et hektisk arbejdsliv til en pensionisttilværelse får de fleste til at tænke over økonomien - kan det hele hænge sammen? - Men start med mulighederne i stedet for bekymringerne og stil spørgsmålet: Hvordan vil jeg leve, når jeg holder op med at arbejde? Og dernæst: Er der plads i økonomien til at få nogle drømme til at ske?',
        image: '/static/gfx/content/articles/penly-article-15.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'skab-en-god-overgang-til-pension',
        slug: 'skab-en-god-overgang-til-pension',
        title: 'Skab en god  <span class="color-highlight"> overgang </span> fra fuldtidsarbejde til folkepension',
        date: new Date(2023, 10, 25),
        resume: 'I mere end 40 år har dit liv været centreret omkring dit arbejde. Det har givet dig identitet, udfordringer og socialt sammenhold. Inden man ved af det, nærmer du dig folkepensionsalderen, og du begynder at spekulere på hvordan du skal trække stikket. I denne artikel vil vi gerne inspirere dig til at overveje dine muligheder, så du får så god en overgang som muligt.',
        image: '/static/gfx/content/articles/penly-article-14.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'i-hvilken-raekkefoelge-skal-man-bruge-sine-penge-naar-man-gaar-paa-pension',
        slug: 'i-hvilken-raekkefoelge-skal-man-bruge-sine-penge-naar-man-gaar-paa-pension',
        title: 'I hvilken <span class="color-highlight">rækkefølge</span> skal man bruge sine penge, når man går på pension?',
        date: new Date(2023, 10, 24),
        resume: 'Pensionisttilværelsen er en livsfase, som mange ser frem til. Det er tidspunktet, hvor du kan nyde frugterne af dit arbejde og bruge mere tid på de ting, du virkelig holder af. Men for at opnå økonomisk tryghed og frihed som pensionist, er det vigtigt at have en velovervejet plan for, hvordan du bruger din opsparing.',
        image: '/static/gfx/content/articles/penly-article-13.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'tove-har-faaet-overblik-over-pensionsoekonomien-og-indre-ro',
        slug: 'tove-har-faaet-overblik-over-pensionsoekonomien-og-indre-ro',
        title: 'Sådan fik Tove overblik over <span class="color-highlight">pensionsøkonomien</span> med uvildig rådgivning',
        date: new Date(2023, 7, 28),
        resume: 'Nedsparingsrådgivningen har givet mig et super godt overblik og en indre ro. Læs mere om, hvad Tove fik ud af rådgivningen.',
        image: '/static/gfx/content/articles/penly-article-12-tove-nedsparing.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'opnaa-oekonomisk-tryghed-med-en-nedsparingsraadgivning',
        slug: 'opnaa-oekonomisk-tryghed-med-en-nedsparingsraadgivning',
        title: 'Opnå økonomisk tryghed med en <span class="color-highlight">nedsparings rådgivning</span> og få flere penge til dig selv',
        date: new Date(2023, 7, 27),
        resume: 'Du har sparet op til pension, siden den dag du satte din fod på arbejdsmarkedet, men reglerne omkring pension og pensionstillæg komplicerede, hvilket resulterer i, at mange går glip af penge. Simpelthen fordi de bruger pengene i en uhensigtsmæssig rækkefølge.',
        image: '/static/gfx/content/articles/penly-article-11-nedsparing.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'rene-holten-poulsen-fandt-8600-kr',
        slug: 'rene-holten-poulsen-fandt-8600-kr',
        title: 'René Holten Poulsen fandt 8.600 kr.<span class="color-highlight"> Tjek selv, om du har penge, der venter på at blive fundet</span>',
        date: new Date(2022, 11, 5),
        resume: 'Tænk på dine 3 nærmeste venner. Fortæl dem nu, at mindst én af jer 4 har 15.000 kr., som I vil miste, hvis ikke I gør noget ved det nu. I ville helt sikkert alle sammen tjekke hvem af jer det var. Langt de færreste er klar over, at de har klatpensioner, som de risikerer at miste. I Danmark har vi tilsammen ca. 7 mia. kr. i de helt små glemte pensioner, der er i fare for at gå i nul. Her skal du møde René Holten Poulsen, som ved hjælp af Penly fandt 8.600 kr. på en klatpension, som ville være forsvundet, hvis ikke han havde gjort noget ved dem.',
        image: '/static/gfx/content/articles/penly-article-10-rene-holten-poulsen-action.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'klatpension',
                name: 'Klatpension',
            },
        ],
    },
    {
        id: '10-gode-raad-inden-du-tager-en-investeringsbeslutning',
        slug: '10-gode-raad-inden-du-tager-en-investeringsbeslutning',
        title: '10 gode råd inden du tager en <span class="color-highlight">investerings-beslutning</span>',
        date: new Date(2022, 10, 23),
        resume: 'Mange Penly brugere spørger os, om de skal foretage ændringer i deres investeringsportefølje i det nuværende marked, hvor kurserne svinger mere end forlystelserne i Tivoli. Derfor har vi her samlet 10 gode råd, som du bør overveje, inden du beslutter dig om en eventuel ændring i din nuværende portefølje.',
        image: '/static/gfx/content/penly-content-12.jpg',
        blog_category: {
            id: 'investering',
            title: 'Investering',
        },
        tags: [],
    },
    {
        id: '6-gode-raad-til-hvordan-du-skaber-et-meningsfuldt-seniorliv',
        slug: '6-gode-raad-til-hvordan-du-skaber-et-meningsfuldt-seniorliv',
        title: '6 gode råd til hvordan du skaber et <span class="color-highlight">meningsfuldt seniorliv</span>',
        date: new Date(2022, 10, 16),
        resume: 'En god pensionsopsparing er guld værd, men den kan ikke sikre dig et meningsfuldt pensionsliv. Et rigt pensionsliv handler i høj grad også om livskvalitet i den næste periode i dit liv, når du har sagt farvel til dit arbejdsliv.Dit pensionsliv skal give mening for netop dig. Det skal have indhold og give dig identitet.',
        image: '/static/gfx/content/penly-content-59.webp',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'senior',
                name: 'Senior',
            },
        ],
    },
    {
        id: 'realkreditlaan',
        slug: 'realkreditlaan',
        title: 'Forstå dit <span class="color-highlight">realkreditlån</span>',
        date: new Date(2022, 8, 23),
        resume: 'Denne artikel er til dig, der vil forstå hvad et realkreditlån er. Der tales meget om, at man kan tjene penge på at lægge sit realkreditlån om, men hvorfor kan det betale sig? Hvad kan man vinde på det, og hvad skal du være særligt opmærksom på? Det forsøger denne artikel at give dig svaret på.',
        image: '/static/gfx/content/penly-content-48.webp',
        blog_category: {
            id: 'realkredit',
            title: 'Realkredit',
        },
        tags: [
            {
                id: 'bolig',
                name: 'Bolig',
            },
        ],
    },
    {
        id: 'anni-fik-den-raadgivning-hun-ikke-fik-i-banken',
        slug: 'anni-fik-den-raadgivning-hun-ikke-fik-i-banken',
        title: 'Anni fik den rådgivning hun ikke fik i <span class="color-highlight">banken</span>',
        date: new Date(2022, 5, 27),
        resume: 'Pensionsalderen nærmer sig og Anni mente, at det var tid til at tale med en økonomisk rådgiver, men hvor går man hen, når banken ikke er uvildig?',
        image: '/static/gfx/content/penly-content-47.webp',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'hvad-er-min-bolig-vaerd-se-de-6-bedste-onlinevurderinger',
        slug: 'hvad-er-min-bolig-vaerd-se-de-6-bedste-onlinevurderinger',
        title: 'Hvad er min bolig værd? Se de 6 bedste <span class="color-highlight">onlinevurderinger</span>',
        date: new Date(2022, 5, 23),
        resume: 'Boligpriserne har været på himmelflugt i lang tid og renterne har været historisk lave. Det betyder, at det måske kan være fordelagtigt for dig at lægge lån om, og skære en god bid af din gæld. Og at du måske kan få en lavere belåningsgrad, som betyder at du skal betale en lavere månedlig ydelse, og måske kan spare på bidraget til dit realkreditinstitut.',
        image: '/static/gfx/content/penly-content-46.webp',
        blog_category: {
            id: 'realkredit',
            title: 'Realkredit',
        },
        tags: [
            {
                id: 'boligvaerdi',
                name: 'Boligværdi',
            },
        ],
    },
    {
        id: 'saadan-forbereder-du-dig-paa-moedet-med-din-pensionsraadgiver',
        slug: 'saadan-forbereder-du-dig-paa-moedet-med-din-pensionsraadgiver',
        title: 'Sådan <span class="color-highlight">forbereder</span> du dig på mødet med din pensionsrådgiver',
        date: new Date(2022, 2, 29),
        resume: 'Har du netop skiftet job, er der god grund til at tage dine pensionsopsparinger op til overvejelse, for måske skal du samle dem eller investere anderledes? Brug Penlys gratis værktøjer til at danne dig et overblik over dine pensioner og forberede dig på mødet med pensionsrådgiveren fra din arbejdsplads. På den måde ved du, hvilke spørgsmål du skal huske at stille.',
        image: '/static/gfx/content/penly-content-44.webp',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'jobskifte',
                name: 'Jobskifte',
            },
            {
                id: 'pensionsopsparing',
                name: 'Pensionsopsparing',
            },
        ],
    },
    {
        id: 'saadan-forbereder-du-dig-smartest-til-pensionen',
        slug: 'saadan-forbereder-du-dig-smartest-til-pensionen',
        title: 'Sådan forbereder du dig smartest til <span class="color-highlight">pensionen</span>',
        date: new Date(2022, 2, 14),
        resume: 'Er du fyldt 50 år, bør du se dine pensionsopsparinger efter i sømmene. Få en uvildig rådgiver til at hjælpe med at lave den rette nedsparingsplan, så du får mest muligt ud af opsparingen - der kan være ca. 1.000 kr. ekstra om måneden efter skat at hente blot ved at optimere dine udbetalinger.',
        image: '/static/gfx/content/penly-content-43.webp',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'nedpsparing',
                name: 'Nedpsparing',
            },
        ],
    },
    {
        id: 'saadan-fik-essy-styr-paa-sine-klatpensioner',
        slug: 'saadan-fik-essy-styr-paa-sine-klatpensioner',
        title: 'Sådan fik Essy styr på sine <span class="color-highlight">klatpensioner</span>',
        date: new Date(2021, 11, 17),
        resume: 'Danskerne sparer op til pension som aldrig før, men samtidig fosser pengene ud af pensionsordningerne, fordi vi glemmer at sikre os ordentlige forhold for vores pensioner. Ifølge Konkurrence- og Forbrugerstyrrelsen har vi 7 mia. kr. stående på klatpensioner. Altså penge som forsvinder helt af sig selv, hvis ikke vi gør noget ved dem. Essy Basseri fik gennem Penly hjælp til at få styr på sine klatpensioner og det har været en lettelse for ham.',
        image: '/static/gfx/content/articles/penly-article-9-essy-basseri-1.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'klatpension',
                name: 'Klatpension',
            },
        ],
    },
    {
        id: 'red-din-klatpension-og-faa-udsigt-til-en-bedre-seniortilvaerelse',
        slug: 'red-din-klatpension-og-faa-udsigt-til-en-bedre-seniortilvaerelse',
        title: 'Red din klatpension og få udsigt til en bedre <span class="color-highlight">seniortilværelse</span>',
        date: new Date(2021, 10, 15),
        resume: 'Vi danskere har 7 mia. kroner stående i klatpensioner. Altså penge som forsvinder helt af sig selv, hvis ikke vi gør noget ved dem. Vi har gjort det nemt for dig at tage hånd om dine klatpensioner, så du kan se dem yngle i stedet for at se dem blive spist af gebyrer.',
        image: '/static/gfx/content/articles/penly-article-8-klatpension.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'klatpension',
                name: 'Klatpension',
            },
        ],
    },
    {
        id: 'en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension',
        slug: 'en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension',
        title: 'Nedsparingsrådgivning gav Birthe <span class="color-highlight">300.000 kr. mere til pension</span>',
        date: new Date(2021, 7, 9),
        resume: 'Birthe tog et digitalt pensionstjek og efterfølgende en nedsparingsrådgivning hos en uvildig rådgiver - det skulle vise sig at være en god investering.',
        image: '/static/gfx/content/articles/penly-article-7-birthe-monrad-1.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'nedsparing',
                name: 'Nedsparing',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'morten-fik-hjaelp-til-at-optimere-sin-pension',
        slug: 'morten-fik-hjaelp-til-at-optimere-sin-pension',
        title: 'Morten fik hjælp til at optimere sin pension. <span class="color-highlight">Vil du også blive klogere på din pension?</span>',
        date: new Date(2021, 5, 21),
        resume: 'Når man er ung, føles pension uendeligt langt væk og mange ofrer det ikke meget opmærksomhed. I takt med at man bliver ældre, bliver pension mere og mere interessant. Det var også tilfældet for Morten Schjøtz-Pedersen, som benyttede sig af et digitalt pensionstjek og efterfølgende uvildig rådgivning med en pensionsrådgiver. Rigtig mange kan have glæde af at få kigget deres pension efter i sømmene. Tallene viser nemlig, at vi danskere snyder os selv for utrolig mange penge.',
        image: '/static/gfx/content/articles/penly-article-6-morten-schjoetz-pedersen-1.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'stine-fik-et-nyt-syn-paa-pension-efter-hun-tog-penlys-pensionstjek',
        slug: 'stine-fik-et-nyt-syn-paa-pension-efter-hun-tog-penlys-pensionstjek',
        title: 'Stine fik et nyt syn på pension, efter hun tog <span class="color-highlight">Penlys PensionsTjek</span>',
        date: new Date(2022, 8, 23),
        resume: 'Stine Olivarius Jakobsen fik en øjenåbner efter at have taget Penlys PensionsTjek. Pension gik fra at være noget der &quot;bare var der&quot; til at være noget som Stine havde overblik over, og som hun havde taget aktivt stilling til. Små justeringer gjorde også, at Stine nu bliver bedre stillet som pensionist.',
        image: '/static/gfx/content/articles/penly-article-5-content-stine-olivarius-jakobsen-1.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
            {
                id: 'pensiontjek',
                name: 'Penly PensionTjek',
            },
        ],
    },
    {
        id: 'staa-staerkt-oekonomisk-som-pensionist',
        slug: 'staa-staerkt-oekonomisk-som-pensionist',
        title: 'Stå stærkt <span class="color-highlight">økonomisk</span> som pensionist',
        date: new Date(2021, 3, 12),
        resume: 'For rigtig mange er årene op til pension en dejlig tid, hvor man kan se frem til at nyde sit otium, efter mange år på arbejdsmarkedet. For nogle kan det være forbundet med en vis frustration, da man ved at ens økonomi vil ændre sig markant. Derfor har vi lavet denne guide til dig, der nærmer sig pensionsalderen eller måske allerede er gået på pension. Her får du svar på, hvad du bør tage højde for og hvad du kan gøre lige nu, for at forbedre din økonomiske situation som pensionist.',
        image: '/static/gfx/content/penly-content-15.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'nedsparing',
                name: 'Nedsparing',
            },
        ],
    },
    {
        id: 'dit-seniorliv-bliver-afgjort-af-det-du-goer-i-dag',
        slug: 'dit-seniorliv-bliver-afgjort-af-det-du-goer-i-dag',
        title: 'Dit seniorliv bliver afgjort af det du gør <span class="color-highlight">i dag</span>',
        date: new Date(2021,3,6),
        resume: 'Pensionsopsparingen er for de fleste den vigtigste opsparing i livet. Ja, pensionslivet ligger måske langt væk. Men de valg du træffer nu, er afgørende for, hvilket seniorliv du får - vi sætter fokus på afkast og risiko på dine pensionsinvesteringer.',
        image: '/static/gfx/content/penly-content-16.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [],
    },
    {
        id: 'uvildig-raadgivning-en-god-beslutning',
        slug: 'uvildig-raadgivning-en-god-beslutning',
        title: '<span class="color-highlight">Uvildig rådgivning</span> blev en af Torbens bedste beslutninger',
        date: new Date(2021,2,21),
        resume: 'Livet som pensionist er noget mange danskere ser frem til, og det er med god grund: det er her vi kan nyde vores tilværelse, trække os tilbage fra arbejdet og investere noget tid i os selv. Men pension betyder for de fleste også, at deres økonomi bliver markant ændret og det kan være en udfordring at vide hvordan man får mest ud af sin økonomi.',
        image: '/static/gfx/content/penly-testimonial-person-torben.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'nedsparing',
                name: 'Nedsparing',
            },
            {
                id: 'uvildig-raadgivning',
                name: 'Uvildig rådgivning',
            },
        ],
    },
    {
        id: 'saadan-faar-du-mest-ud-af-din-pension',
        slug: 'saadan-faar-du-mest-ud-af-din-pension',
        title: 'Sådan får du mest ud af din <span class="color-highlight">pension</span>',
        date: new Date(2021,8,23),
        resume: 'Mange har svært ved at forholde sig til deres pension, før de rent faktisk er på vej ud af arbejdsmarkedet. Men der er rigtig mange gode grunde til at gøre det, for der er mange penge at vinde ved det. Danske Penly har udviklet et værktøj, der gør det nemt for dig at få overblik over din pension og giver dig her opskriften på, hvordan du får forbedret dine muligheder for en bedre stillet pensionisttilværelse.',
        image: '/static/gfx/content/penly-content-14.jpg',
        blog_category: {
            id: 'pension',
            title: 'Pension',
        },
        tags: [
            {
                id: 'pensiontjek',
                name: 'Penly PensionTjek',
            },
            {
                id: 'nedsparing',
                name: 'Nedsparing',
            },
        ],
    },
];

export const getMockArticleData = () => articles;
